import React, { useEffect } from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
const ClassTeacherListSenior = () => {
  useEffect(() => {
    document.title =
      "Class Teacher List Senior -  The Air Force School Subroto Park";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>{" "}
          </li>
          <li> Academics</li>
          <li>List of Class Teachers</li>
          <li> Class Teacher List (Senior)</li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Class Teacher List (Senior)</h1>
            </div>
          </div>
          <div className="row">
            <div className="table-responsive maintable">
              <table className="table">
                <thead>
                  <tr>
                    <th>Class</th>
                    <th> Sec</th>
                    <th>R. No.</th>
                    <th> Location</th>
                    <th colspan="2">Initial and name of Class Teacher</th>

                    <th colspan="2">Initial and name of Standby Teacher</th>

                    <th>Class Reps</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td rowspan="6">VI</td>
                    <td>A</td>
                    <td>36</td>
                    <td>SF-MB</td>
                    <td>MNA</td>
                    <td>Ms Manisha Sachdeva</td>
                    <td>MNV</td>
                    <td>Ms. Moni Verma</td>
                    <td rowspan="6">MNA</td>
                  </tr>
                  <tr>
                    <td>B</td>
                    <td>37</td>
                    <td>SF-MB</td>
                    <td>KAN</td>
                    <td>Ms Kanika Kaushik</td>
                    <td>MVJ</td>
                    <td>Ms Malvika Jain</td>
                  </tr>
                  <tr>
                    <td>C</td>
                    <td>38</td>
                    <td>SF-MB</td>
                    <td>BHD</td>
                    <td>Ms. Bhoomika Dabas</td>
                    <td>MNY</td>
                    <td>Ms Manisha Yadav</td>
                  </tr>
                  <tr>
                    <td>D</td>
                    <td>47</td>
                    <td>SF-NB</td>
                    <td>MNP</td>
                    <td>Ms Meenakshi Pal</td>
                    <td>YSH</td>
                    <td>Ms. Yoshita</td>
                  </tr>
                  <tr>
                    <td>E</td>
                    <td>48</td>
                    <td>SF-NB</td>
                    <td>NBH</td>
                    <td>Ms Neeharika Bhatnagar</td>
                    <td>CHM</td>
                    <td>Ms Chetna Mavi</td>
                  </tr>
                  <tr>
                    <td>F</td>
                    <td>49</td>
                    <td>SF-NB</td>
                    <td>NHA</td>
                    <td>Ms Nisha Bud Chauhan</td>
                    <td>ABD</td>
                    <td>Mr Abhishek Demlani</td>
                  </tr>
                  <tr>
                    <td rowspan="5">VII</td>
                    <td>A</td>
                    <td>31</td>
                    <td>SF-MB</td>
                    <td>HRC</td>
                    <td>Mr. Harish Chandra</td>
                    <td>RCM</td>
                    <td>Ms. Ruchi Mittal</td>
                    <td rowspan="5">MGW</td>
                  </tr>
                  <tr>
                    <td>B</td>
                    <td>32</td>
                    <td>SF-MB</td>
                    <td>HMS</td>
                    <td>Ms Himani Sharma</td>
                    <td>MNV</td>
                    <td>Ms. Moni Verma</td>
                  </tr>
                  <tr>
                    <td>C</td>
                    <td>33</td>
                    <td>SF-MB</td>
                    <td>MGW</td>
                    <td>Ms Megha Walia</td>
                    <td>TMG</td>
                    <td>Ms Timsi Gupta</td>
                  </tr>
                  <tr>
                    <td>D</td>
                    <td>34</td>
                    <td>SF-MB</td>
                    <td>PHM</td>
                    <td>Ms Prachi Manocha</td>
                    <td>CHM</td>
                    <td>Ms Chetna Mavi</td>
                  </tr>
                  <tr>
                    <td>E</td>
                    <td>35</td>
                    <td>SF-MB</td>
                    <td>DTJ</td>
                    <td>Ms Deepti Jain</td>
                    <td>RKS</td>
                    <td>Dr. Rohit Kr Sharma</td>
                  </tr>

                  <tr>
                    <td rowspan="6">VIII</td>
                    <td>A</td>
                    <td>46</td>
                    <td>FF-NB</td>
                    <td>RHB</td>
                    <td>Mr. Rahul Bhatt</td>
                    <td>MVJ</td>
                    <td>Ms Malvika Jain</td>
                    <td rowspan="6">PRS</td>
                  </tr>
                  <tr>
                    <td>B</td>
                    <td>45</td>
                    <td>FF-NB</td>
                    <td>PRS</td>
                    <td>Ms Priti Bhardwaj</td>
                    <td>SKM</td>
                    <td>Ms. Sarika Mishra</td>
                  </tr>
                  <tr>
                    <td>C</td>
                    <td>44</td>
                    <td>FF-NB</td>
                    <td>RGT</td>
                    <td>Ms Ruchi Gupta</td>
                    <td>ABD</td>
                    <td>Mr Abhishek Demlani</td>
                  </tr>
                  <tr>
                    <td>D</td>
                    <td>43</td>
                    <td>GF-NB</td>
                    <td>DVS</td>
                    <td>Ms Divya Shokeen</td>
                    <td>MKS</td>
                    <td>Ms. Surbhi kanan</td>
                  </tr>
                  <tr>
                    <td>E</td>
                    <td>42</td>
                    <td>GF-NB</td>
                    <td>SGH</td>
                    <td>Ms Sweta Singh</td>
                    <td>TMG</td>
                    <td>Ms Timsi Gupta</td>
                  </tr>
                  <tr>
                    <td>F</td>
                    <td>41</td>
                    <td>GF-NB</td>
                    <td>ADK</td>
                    <td>Ms Amandeep Kaur</td>
                    <td>RCM</td>
                    <td>Ms Richa Mittal</td>
                  </tr>
                  <tr>
                    <td rowspan="6">IX</td>
                    <td>A</td>
                    <td>29</td>
                    <td>SF-MB</td>
                    <td>PNM</td>
                    <td>Ms Poonam Saha</td>
                    <td>RKS</td>
                    <td>Dr. Rohit Kr Sharma</td>
                    <td rowspan="6">PST</td>
                  </tr>
                  <tr>
                    <td>B</td>
                    <td>27</td>
                    <td>SF-MB</td>
                    <td>PST</td>
                    <td>Ms Pooja Sethi</td>
                    <td>GHR</td>
                    <td>Ms. Grisha Ros G</td>
                  </tr>
                  <tr>
                    <td>C</td>
                    <td>24</td>
                    <td>FF-MB</td>
                    <td>HIR</td>
                    <td>Dr Hira Irfan</td>
                    <td>SDR</td>
                    <td>Ms Swati Dhingra</td>
                  </tr>
                  <tr>
                    <td>D</td>
                    <td>28</td>
                    <td>SF-MB</td>
                    <td>ADU</td>
                    <td>Ms Ankita Duhan</td>
                    <td>KSH</td>
                    <td>Ms. Khushi</td>
                  </tr>
                  <tr>
                    <td>E</td>
                    <td>22</td>
                    <td>FF-MB</td>
                    <td>JYN</td>
                    <td>Ms Jyotsana Narang</td>
                    <td>MNY</td>
                    <td>Ms Manisha Yadav</td>
                  </tr>
                  <tr>
                    <td>F</td>
                    <td>30</td>
                    <td>SF-MB</td>
                    <td>VVD</td>
                    <td>Ms Vandana Devi</td>
                    <td>SKM</td>
                    <td>Ms. Sarika Mishra</td>
                  </tr>

                  <tr>
                    <td rowspan="5">X</td>
                    <td>A</td>
                    <td>17</td>
                    <td>FF-MB</td>
                    <td>VJT</td>
                    <td>Ms Vyanjana Tyagi</td>
                    <td>SDR</td>
                    <td>Ms Swati Dhingra</td>
                    <td rowspan="5">GTN</td>
                  </tr>
                  <tr>
                    <td>B</td>
                    <td>18</td>
                    <td>FF-MB</td>
                    <td>DAT</td>
                    <td>Ms Divya Tyagi</td>
                    <td>ANR</td>
                    <td>Mr. Anand Roy</td>
                  </tr>
                  <tr>
                    <td>C</td>
                    <td>19</td>
                    <td>FF-MB</td>
                    <td>MTN</td>
                    <td>Ms Mithun Sarkar</td>
                    <td>ANR</td>
                    <td>Mr. Anand Roy</td>
                  </tr>
                  <tr>
                    <td>D</td>
                    <td>20</td>
                    <td>FF-MB</td>
                    <td>GTN</td>
                    <td>Ms Geetanjali</td>
                    <td>GHR</td>
                    <td>Ms. Grisha Ros G</td>
                  </tr>
                  <tr>
                    <td>E</td>
                    <td>21</td>
                    <td>FF-MB</td>
                    <td>PRK</td>
                    <td>Ms Prabha Kathait</td>
                    <td>SJT</td>
                    <td>Mr. Sujeet Chhikara</td>
                  </tr>

                  <tr>
                    <td rowspan="5">XI</td>
                    <td>A</td>
                    <td>12</td>
                    <td>GF-MB</td>
                    <td>NNG</td>
                    <td>Ms Nishu Nigam</td>
                    <td>VNS</td>
                    <td>Ms Vineti Sethi</td>
                    <td rowspan="5">RSA</td>
                  </tr>
                  <tr>
                    <td>B</td>
                    <td>GEOLAB</td>
                    <td>GF-MB</td>
                    <td>MNK</td>
                    <td>Mr Manash Kumar</td>
                    <td>RJM</td>
                    <td>Ms. Rimjhim</td>
                  </tr>
                  <tr>
                    <td>C</td>
                    <td>14</td>
                    <td>FF-MB</td>
                    <td>RSA</td>
                    <td>Mr Rishi Arora</td>
                    <td>NTY</td>
                    <td>Ms Nitya Tomar</td>
                  </tr>
                  <tr>
                    <td>D</td>
                    <td>15</td>
                    <td>FF-MB</td>
                    <td>NEG</td>
                    <td>Ms Neha Gupta</td>
                    <td>ASN</td>
                    <td>Ms Ashma Sriram</td>
                  </tr>
                  <tr>
                    <td>E</td>
                    <td>16</td>
                    <td>FF-MB</td>
                    <td>MNG</td>
                    <td>Ms Manisha Goyal</td>
                    <td>SJT</td>
                    <td>Mr. Sujeet Chhikara</td>
                  </tr>

                  <tr>
                    <td rowspan="5">XII</td>
                    <td>A</td>
                    <td>7</td>
                    <td>GF-MB</td>
                    <td>ACD</td>
                    <td>Ms Aanchal Dewan</td>
                    <td>TSC</td>
                    <td>Dr Tanima S Chakravarti</td>
                    <td rowspan="5">ACD</td>
                  </tr>
                  <tr>
                    <td>B</td>
                    <td>6</td>
                    <td>GF-MB</td>
                    <td>SRG</td>
                    <td>Dr. Saurabh Gupta</td>
                    <td>ASN</td>
                    <td>Ms Ashma Sriram</td>
                  </tr>
                  <tr>
                    <td>C</td>
                    <td>5</td>
                    <td>GF-MB</td>
                    <td>NER</td>
                    <td>Ms Neelam Ruhil</td>
                    <td>NTY</td>
                    <td>Ms Nitya Tomar</td>
                  </tr>
                  <tr>
                    <td>D</td>
                    <td>4</td>
                    <td>GF-MB</td>
                    <td>GJN</td>
                    <td>Ms Gunjan</td>
                    <td>PKC</td>
                    <td>Mr Pradipta Chahataray</td>
                  </tr>
                  <tr>
                    <td>E</td>
                    <td>3</td>
                    <td>GF-MB</td>
                    <td>KCB</td>
                    <td>Ms Kirti Chhabra</td>
                    <td>SBR</td>
                    <td>Ms Sumita Balarm</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClassTeacherListSenior;
